import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import type { WidgetConfig } from '../types';

interface OfflineViewProps {
  config: WidgetConfig;
}

export const OfflineView: React.FC<OfflineViewProps> = ({ config }) => {
  const { t } = useTranslation(config.behavior?.locale);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    // In a full implementation this would POST to the API
    setSubmitted(true);
  };

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center px-6 text-center"
      style={{ fontFamily: config.branding.font_family || 'system-ui, sans-serif' }}
    >
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
        style={{ backgroundColor: config.branding.primary_color + '20' }}
      >
        <Mail size={24} style={{ color: config.branding.primary_color }} />
      </div>

      <p className="text-sm text-gray-600 mb-6 leading-relaxed">
        {config.behavior.offline_message}
      </p>

      {config.behavior.collect_email_offline && !submitted && (
        <form onSubmit={handleSubmit} className="w-full max-w-xs space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('offline.emailPlaceholder')}
            required
            className="w-full text-sm px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-300"
          />
          <button
            type="submit"
            className="w-full text-sm font-medium py-2.5 rounded-xl text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: config.branding.primary_color }}
          >
            {t('offline.notifyMe')}
          </button>
        </form>
      )}

      {submitted && (
        <p className="text-sm text-green-600 font-medium">
          {t('offline.confirmation')}
        </p>
      )}
    </div>
  );
};
